import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function HoodIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M26.9042 8.50135C27.8827 7.95366 28.995 7.66416 30.1208 7.66416C30.6064 7.66416 31 7.27669 31 6.79876C31 6.32083 30.6064 5.93336 30.1208 5.93336C28.6908 5.93336 27.278 6.3011 26.035 6.99682L20.4316 10.1331L23.0783 10.6428L26.9042 8.50135Z"
        fill="currentColor"
      />
      <path
        d="M25.4939 14.5576C25.4939 15.4328 26.2173 16.1448 27.1065 16.1448H29.5644C28.739 14.5843 27.2836 13.3832 25.494 12.8918V14.5576H25.4939Z"
        fill="currentColor"
      />
      <path
        d="M9.77937 5.96169C8.79817 5.33254 7.66065 5 6.4896 5H1.87921C1.39365 5 1 5.38747 1 5.8654V10.1752H16.3506L9.77937 5.96169Z"
        fill="currentColor"
      />
      <path
        d="M12.852 18.1329C14.1557 16.8497 15.889 16.143 17.7326 16.143C19.5763 16.143 21.3096 16.8497 22.6133 18.1329C23.2665 18.7758 23.7726 19.525 24.1151 20.3408H30.3069V19.1362C30.3069 18.706 30.2625 18.2847 30.1803 17.8756H27.1065C25.2477 17.8756 23.7355 16.3872 23.7355 14.5576V12.5329L20.4796 11.906H1V20.3407H11.3502C11.6926 19.525 12.1987 18.7758 12.852 18.1329ZM6.3746 16.97H5.35073C4.86518 16.97 4.47153 16.5826 4.47153 16.1046C4.47153 15.6267 4.86518 15.2392 5.35073 15.2392H6.3746C6.86016 15.2392 7.25381 15.6267 7.25381 16.1046C7.25381 16.5826 6.86016 16.97 6.3746 16.97Z"
        fill="currentColor"
      />
      <path
        d="M17.7326 22.0715C17.2478 22.0715 16.8534 22.4597 16.8534 22.9369C16.8534 23.4141 17.2478 23.8023 17.7326 23.8023C18.2175 23.8023 18.6118 23.4141 18.6118 22.9369C18.6118 22.4597 18.2175 22.0715 17.7326 22.0715Z"
        fill="currentColor"
      />
      <path
        d="M17.7326 17.8738C14.8917 17.8738 12.5887 20.1406 12.5887 22.9369C12.5887 25.7332 14.8917 28 17.7326 28C20.5735 28 22.8765 25.7332 22.8765 22.9369C22.8765 20.1406 20.5735 17.8738 17.7326 17.8738ZM17.7326 25.5331C16.2782 25.5331 15.095 24.3684 15.095 22.9369C15.095 21.5054 16.2782 20.3407 17.7326 20.3407C19.187 20.3407 20.3703 21.5054 20.3703 22.9369C20.3703 24.3684 19.1871 25.5331 17.7326 25.5331Z"
        fill="currentColor"
      />
      <path
        d="M10.8856 22.0715H1V24.6677C1 25.1456 1.39365 25.5331 1.87921 25.5331H11.3502C11.0091 24.7208 10.8303 23.8423 10.8303 22.9369C10.8303 22.6451 10.8491 22.3563 10.8856 22.0715Z"
        fill="currentColor"
      />
      <path
        d="M30.1207 22.0715H24.5796C24.6162 22.3563 24.6349 22.6451 24.6349 22.9369C24.6349 23.8424 24.4561 24.7208 24.1151 25.5331H30.1207C30.6063 25.5331 30.9999 25.1456 30.9999 24.6677V22.9369C30.9999 22.459 30.6063 22.0715 30.1207 22.0715Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
